import { FC, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { clearObjective, getObjective } from '~src/store/okrs/actions';
import { StoreI } from '~src/rootReducer';
import LoadingSpinner from '~src/shared/loadingSpinner/LoadingSpinner';
import { showNotification } from '~src/store/app/actions';
import { ShowNotification } from '~src/store/app/interfaces';
import { ObjectiveItem } from '~src/store/okrs/interfaces';
import { PageContentContainer } from '~src/styles/containers.sc';

import ObjectiveDetailsForm from './ObjectiveDetailsForm';

interface DispatchProps {
  getObjective: (id: string) => void;
  clearObjective: (id: string) => void;
  showNotification: ShowNotification;
}

type Props = DispatchProps & RouteComponentProps<any>;

const ObjectiveDetails: FC<Props> = (props) => {
  const { objectiveDetails, loadingSingle, wantedObjectiveId } = useSelector((state: StoreI) => {
    const existingObjectiveDetails: ObjectiveItem | undefined = state.okrs.objectives.objectiveDetails;
    const wantedObjectiveId = props.match.params.objectiveId;
    const wantedObjectiveDetails =
      existingObjectiveDetails && existingObjectiveDetails.id === wantedObjectiveId
        ? existingObjectiveDetails
        : undefined;
    return {
      objectiveDetails: wantedObjectiveDetails,
      loadingSingle: state.okrs.objectives.loadingSingle,
      wantedObjectiveId,
    };
  });

  useEffect(() => {
    if (!objectiveDetails && !loadingSingle && wantedObjectiveId) {
      props.getObjective(wantedObjectiveId);
    }
  }, [objectiveDetails]);

  const reloadObjective = () => {
    props.getObjective(wantedObjectiveId);
    props.clearObjective(wantedObjectiveId);
  };

  return (
    <PageContentContainer>
      {loadingSingle ? (
        <LoadingSpinner alignCls="center-middle" />
      ) : (
        objectiveDetails && (
          <ObjectiveDetailsForm
            objective={objectiveDetails}
            reloadObjective={reloadObjective}
            key={objectiveDetails.id}
          />
        )
      )}
    </PageContentContainer>
  );
};

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  getObjective: (id) => dispatch(getObjective(id)),
  clearObjective: (id) => dispatch(clearObjective(id)),
  showNotification: (notification) => dispatch(showNotification(notification)),
});

const ObjectiveDetailsConnected = connect(null, mapDispatchToProps)(withRouter(ObjectiveDetails));
export default ObjectiveDetailsConnected;
